import { signInWithRedirect } from 'aws-amplify/auth/cognito'
import { Button } from '@/components/ui/button'
import GoogleLogo from '@/assets/icons/google-logo'
import './styles.css'

function SignInPage() {
  const currentYear = new Date().getFullYear()

  return (
    <div>
      {/* Logo */}
      <div className="fasten-logo" />
      <div className=" fixed left-32 flex flex-col justify-center items-start h-full min-w-[343px] max-w-[360px] gap-8 ">
        {/* Login Section */}
        <div className="flex flex-col items-start self-stretch">
          <p className="text-3xl font-semibold text-[--gray-900]">Log in</p>
        </div>
        <Button
          type="button"
          variant="outline"
          className="gap-3 text-[--gray-700]"
          onClick={() => signInWithRedirect({ provider: 'Google' })}
        >
          <GoogleLogo />
          Sign in with Google
        </Button>
      </div>

      {/* Footer */}
      <p className="text-sm text-[--gray-600] font-normal absolute bottom-4 left-8">© Fasten Rewards {currentYear}</p>
    </div>
  )
}

export default SignInPage
